module.exports = __webpack_public_path__ + "img/daterange.5d29331e.png";